// import React from 'react';
// import MacRequestList from '../components/mac-requests/MacRequestList';
// import MasterLayout from '../masterLayout/MasterLayout';

import React from 'react';
import MacRequestList from '../components/mac-requests/MacRequestList';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';

const MacRequestListPage = () => {

  return (
    <MasterLayout>
      <Breadcrumb title="MAC Requests" />
      <MacRequestList />
    </MasterLayout>
  );
};

export default MacRequestListPage;


